<template>
  <header class="nx-header">
    <nav class="nx-nav">
      <!-- Left: Brand -->
      <div class="nx-left">
        <button class="nx-brand" type="button" @click="go('/home')">
          <span class="nx-logo" aria-hidden="true">B</span>
          <span class="nx-brand-text">
            <span class="nx-brand-name">BioFlow Studio</span>
            <span class="nx-brand-sub">Workflow Platform</span>
          </span>
        </button>
      </div>

      <!-- Center: Links -->
      <div class="nx-center" role="navigation" aria-label="Primary">
        <button
          v-for="item in items"
          :key="item.path"
          type="button"
          class="nx-link"
          :class="{ 'is-active': isActive(item) }"
          @click="go(item.path)"
        >
          <span class="nx-link-label">{{ item.label }}</span>
        </button>
      </div>

  <div class="nx-right">
    <select class="nx-lang" :value="lang" @change="setLang($event.target.value)">
      <option value="en">English</option>
      <option value="zh">中文</option>
    </select>
      <!-- Right: Actions -->
        <button class="nx-btn nx-btn-ghost" type="button" @click="go('/results')">
          {{ $t("nav.results") }}
        </button>
        <button class="nx-btn nx-btn-primary" type="button" @click="go('/batch')">
          {{ $t("nav.newBuild") }}
        </button>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: "NavBar",
  computed: {
    items() {
      return [
        { label: "Home", path: "/home" },
        { label: "Builder", path: "/batch" },
        { label: "Results", path: "/results" },
        { label: "Help", path: "/help" },
        { label: "About", path: "/about" },
      ];
    },
    lang() {
      return this.$i18n.locale;
    },
  },
  methods: {
    go(path) {
      if (this.$route.path === path) return;
      this.$router.push(path);
    },
    isActive(item) {
      const p = this.$route.path || "";
      if (item.path === "/home") return p.startsWith("/home");
      if (item.path === "/batch") return p.startsWith("/batch");
      return p === item.path;
    },
    setLang(v) {
      this.$i18n.locale = v;
      localStorage.setItem("lang", v);
      document.documentElement.lang = v;
    },
  },
};
</script>

<style scoped>
/* ====== 视觉基调：大厂产品风（白底、清爽、可读性强） ====== */
.nx-header {
  position: sticky;
  top: 0;
  z-index: 50;
  background: #ffffff;
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
}

.nx-nav {
  max-width: 1240px;
  margin: 0 auto;
  padding: 14px 18px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 16px;
}

/* ====== Brand ====== */
.nx-left {
  display: flex;
  align-items: center;
}

.nx-brand {
  border: 0;
  background: transparent;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 10px;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.15s ease;
}

.nx-brand:hover {
  background: rgba(13, 110, 253, 0.06);
  transform: translateY(-1px);
}

.nx-logo {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(13, 110, 253, 1), rgba(102, 16, 242, 1));
  color: #fff;
  font-weight: 800;
  letter-spacing: 0.02em;
  box-shadow: 0 10px 24px rgba(13, 110, 253, 0.18);
}

.nx-brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
  text-align: left;
}

.nx-brand-name {
  font-weight: 800;
  font-size: 14px;
  color: rgba(15, 23, 42, 0.92);
  letter-spacing: 0.02em;
}

.nx-brand-sub {
  font-size: 12px;
  color: rgba(15, 23, 42, 0.55);
}

/* ====== Center links ====== */
.nx-center {
  display: flex;
  gap: 8px;
  padding: 6px;
  background: rgba(15, 23, 42, 0.03);
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 999px;
}

.nx-link {
  border: 0;
  background: transparent;
  cursor: pointer;
  padding: 10px 14px;
  border-radius: 999px;
  font-weight: 650;
  font-size: 13px;
  color: rgba(15, 23, 42, 0.72);
  transition: background 0.15s ease, color 0.15s ease, transform 0.15s ease;
}

.nx-link:hover {
  background: rgba(255, 255, 255, 0.9);
  color: rgba(15, 23, 42, 0.92);
  transform: translateY(-1px);
}

.nx-link.is-active {
  background: #ffffff;
  color: rgba(13, 110, 253, 0.95);
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
  position: relative;
}

.nx-link.is-active::after {
  content: "";
  position: absolute;
  left: 14px;
  right: 14px;
  bottom: 6px;
  height: 2px;
  border-radius: 999px;
  background: rgba(13, 110, 253, 0.85);
}

/* ====== Right actions ====== */
.nx-right {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  align-items: center;
}

.nx-btn {
  border-radius: 12px;
  padding: 10px 14px;
  font-weight: 700;
  font-size: 13px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}

.nx-btn:hover {
  transform: translateY(-1px);
}

.nx-btn-ghost {
  background: rgba(15, 23, 42, 0.03);
  border-color: rgba(15, 23, 42, 0.08);
  color: rgba(15, 23, 42, 0.78);
}

.nx-btn-ghost:hover {
  background: rgba(15, 23, 42, 0.05);
}

.nx-btn-primary {
  background: rgba(13, 110, 253, 1);
  color: #fff;
  box-shadow: 0 12px 26px rgba(13, 110, 253, 0.22);
}

.nx-btn-primary:hover {
  box-shadow: 0 14px 32px rgba(13, 110, 253, 0.28);
}

/* ====== Responsive ====== */
@media (max-width: 860px) {
  .nx-nav {
    grid-template-columns: 1fr;
    gap: 10px;
    padding: 12px 14px;
  }
  .nx-right {
    justify-content: flex-start;
  }
  .nx-center {
    justify-content: space-between;
    overflow-x: auto;
    scrollbar-width: none;
  }
  .nx-center::-webkit-scrollbar {
    display: none;
  }
}
.nx-lang{
  height: 36px;
  border-radius: 12px;
  padding: 0 10px;
  border: 1px solid rgba(15, 23, 42, 0.12);
  background: #fff;
  font-weight: 650;
  font-size: 13px;
}
</style>

